/**
 * Route path → brand-icon name. Lifted from the prototype's `cms-nav.js`
 * (the single source of truth there) so the sidebar nav, the command
 * palette, and any other "render the icon for a route" surface all agree.
 *
 * Keys are the same `path` values that appear in `src/constants/RouteConfig.js`.
 * Values reference glyphs defined in `brandIcons.js`.
 */
const NAV_ICON_BY_PATH = {
  '/dashboard':                         'dashboard',
  '/category':                          'categories',
  '/subcategories':                     'subcategory',
  '/sessions':                          'sessions',
  '/quick-taps':                        'quick_taps',
  '/audiobooks':                        'audiobooks',
  '/challenges':                        'challenges',
  '/series':                            'series',
  '/daily-inspirations':                'daily_inspiration',
  '/card-decks':                        'card_decks',
  '/captions/queue':                    'caption_review',
  '/captions/generate':                 'cc',
  '/captions/vocabulary':               'vocabulary',
  '/captions/translation':              'translation',
  '/authors':                           'edit_account',
  '/tapping-points':                    'tapping',
  '/background-musics':                 'music',
  '/player-avatars':                    'edit_account',
  '/player-backgrounds':                'card_decks',
  '/player-music':                      'music',
  '/media-resources':                   'featured',
  '/quotes':                            'quote',
  '/app-users':                         'edit_account',
  '/feedbacks':                         'support',
  '/requests':                          'notifications',
  '/cancellation-reasons':              'cancel',
  '/user-streak':                       'streak',
  '/premium-management':                'premium',
  '/user-cancellations':                'cancel',
  '/intensity-report':                  'tapping',
  '/research-data':                     'science',
  '/research-user-feedback':            'support',
  '/onboarding':                        'tapping_basics',
  '/banners':                           'premium',
  '/marketing-initiatives':             'share',
  '/attribution-options':               'replay',
  '/engagement/recommended-list':       'recommended',
  '/engagement/popular-list':           'popular',
  '/general-settings':                  'settings',
  '/admins':                            'edit_account',
  '/roles':                             'roles',
  '/api-keys':                          'key',
  '/integrations/clickfunnels-webhook': 'webhook',
  '/my-account':                        'edit_account',
  '/logout':                            'back_arrow',
  '/searches':                          'search',
  '/experiments':                       'science',
  '/goal-content':                      'recommended',
};

export default NAV_ICON_BY_PATH;
